import { render } from "./BaseTransition.vue?vue&type=template&id=7e1fd9f1"
import script from "./BaseTransition.vue?vue&type=script&lang=js"
export * from "./BaseTransition.vue?vue&type=script&lang=js"

import "./BaseTransition.vue?vue&type=style&index=0&id=7e1fd9f1&lang=scss"
script.render = render

export default script